import React, { useEffect } from 'react';
import parse from 'html-react-parser';
import {
  Box,
  Text,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  Flex,
  Container,
} from '@chakra-ui/react';
import Skeleton from 'react-loading-skeleton';

import FaqPublicController, {
  useFaqContext,
} from '../../controller/public/faq';
import { dataFaq } from '../../../../entities/Faq';
import { FiPlus, FiX } from 'react-icons/fi';

const FrequentlyAsked: React.FC = () => {
  const {
    getFaqsData,
    state: { faq: data, isLoading },
  } = useFaqContext();

  useEffect(() => {
    getFaqsData(1, '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box bg="white" py={12}>
      <Container maxW="8xl">
        <Flex
          my={{ base: 8, md: 12 }}
          flexDirection={{ base: 'column', md: 'row' }}
          className="gap-14"
          alignItems={{ base: 'start', md: 'center' }}
        >
          <Box>
            <Text
              fontSize={{ base: '2xl', md: '2xl' }}
              fontWeight="semibold"
              className="mb-2"
            >
              Frequently Ask <br /> Question
            </Text>
            <Text>Pertanyaan paling sering ditanyakan</Text>
          </Box>

          {isLoading ? (
            <Skeleton
              count={5}
              style={{ height: '50px', marginBottom: '20px' }}
            />
          ) : (
            <Accordion
              w={{ base: '100%', md: '70%' }}
              defaultIndex={[0]}
              allowMultiple
            >
              {data.map((item: dataFaq, index) => (
                <AccordionItem key={item.id} bg="white" rounded="md">
                  {({ isExpanded }) => (
                    <Box
                      style={{
                        background: isExpanded
                          ? 'linear-gradient(257.4deg, #FFFFFF -6.81%, #ECFBF6 71.78%)'
                          : 'transparent',
                      }}
                      className="my-4 gap-4"
                      display="flex"
                      alignItems="center"
                    >
                      <Text
                        fontSize="lg"
                        color="gray.600"
                        fontWeight="semibold"
                      >
                        {index < 9 ? `0${index + 1}` : index + 1}
                      </Text>
                      <Box w="full">
                        <AccordionButton
                          w="full"
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                        >
                          <Box
                            display="flex"
                            flex="1"
                            textAlign="left"
                            className="gap-4"
                          >
                            <Text
                              fontSize="lg"
                              color={isExpanded ? 'green.600' : 'gray.600'}
                              fontWeight="semibold"
                            >
                              {item.pertanyaan}
                            </Text>
                          </Box>
                          <Box px="2px" py="0.5px">
                            {isExpanded ? (
                              <FiX fontSize="12px" />
                            ) : (
                              <FiPlus fontSize="12px" />
                            )}
                          </Box>
                        </AccordionButton>

                        <AccordionPanel pb={4}>
                          {parse(item.jawaban)}
                        </AccordionPanel>
                      </Box>
                    </Box>
                  )}
                </AccordionItem>
              ))}
            </Accordion>
          )}
        </Flex>
      </Container>
    </Box>
  );
};

const Faq: React.FC = () => {
  return (
    <FaqPublicController.Provider>
      <FrequentlyAsked />
    </FaqPublicController.Provider>
  );
};

export default Faq;
